module.exports = __webpack_public_path__ + "bin/5886aae2682e7fb8495c2ab453cfa4cf.jpg";